import * as moment from 'moment'
import { validatorPayDay, validatorPresentDays } from '../rules/index'

export default function config() {
  // 企业客户信息
  const m_enterprise_customerInfo = [
    {
      type: 'text',
      label: '客户名称:',
      key: 'customerName',
    },
    {
      type: 'text',
      label: '客户类型:',
      key: 'rentCalculationRules',
    },
    {
      type: 'select',
      label: '选择租赁方案:',
      key: 'planId',
      source: [],
      sourceKey: { label: 'name', value: 'id' },
      options: {
        type: 'text',
        clearable: true,
        filterable: true,
        change_s: (e) => {
          if (Number(e) === 0) { // 自定义
            this.m_enterprise_customerInfoDefaultValue.planId = 0
            this.m_enterprise_customerInfoDefaultValue.planRecordId = ''
            this.$refs.EnterpriseCustomerInfo && this.$refs.EnterpriseCustomerInfo.initParams()

            this.m_enterprise_addVehicleDefaultValue = {}

            //  企业新增关联订单
            if (this.configParams.relatedType === 2) {
              this.m_thecarchange.forEach((current) => {
                if (current.key === 'modelId') {
                  current.options.disabled = false
                }
                if (current.key === 'vehicleStatus') {
                  current.options.disabled = true
                }
                if (current.key === 'plateNo') {
                  current.options.disabled = true
                }
              })
              this.m_thecarchangevalue = {
                vehicleStatus: 3,
              }
              this.$nextTick(() => {
                this.$refs.thecarchange && this.$refs.thecarchange.onClean()
              })
            }


            this.$nextTick(() => {
              this.$refs.AddVehicle.$refs.addVehicle && this.$refs.AddVehicle.$refs.addVehicle.onClean()
            })

            // 重置租赁信息
            this.resetLeaseInfo()
            // 自定义 清空支付计划表格
            this.tableDataFrom.tableData = [...this.defaultTableData]
            // this.changeProvider(item.providerId)
            this.leaseInfoParams.startStopDate = []
          } else {
            this.rentPlanList.forEach((item) => {
              if (Number(item.id) === Number(e)) {
                this.m_enterprise_customerInfoDefaultValue = Object.assign(this.m_enterprise_customerInfoDefaultValue, this.$refs.EnterpriseCustomerInfo.getValidKey())
                this.m_enterprise_customerInfoDefaultValue.planRecordId = item.planRecordId
                this.$refs.EnterpriseCustomerInfo && this.$refs.EnterpriseCustomerInfo.initParams()
                // 车型回显
                this.m_enterprise_addVehicleDefaultValue.modelId = item.modelId
                this.$refs.AddVehicle && this.$refs.AddVehicle.$refs.addVehicle && this.$refs.AddVehicle.$refs.addVehicle.initParams()
                //  企业新增关联订单
                if (this.configParams.relatedType === 2) {
                  this.m_thecarchange.forEach((current) => {
                    if (current.key === 'modelId') {
                      current.options.disabled = true
                    }
                    if (current.key === 'vehicleStatus') {
                      current.options.disabled = false
                    }
                    if (current.key === 'plateNo') {
                      current.options.disabled = false
                    }
                  })
                  this.m_thecarchangevalue.modelId = item.modelId
                  this.$refs.thecarchange && this.$refs.thecarchange.initParams()

                  this.$nextTick(() => {
                    this.$refs.thecarchange && this.$refs.thecarchange.onClean()
                  })
                }
                // 起止日期计算
                this.leaseInfoParams.startStopDate = []
                this.leaseInfoParams.startStopDate[0] = moment(new Date()).add(1, 'day').startOf('day').format('YYYY-MM-DD HH:mm:ss')
                this.leaseInfoParams.startStopDate[1] = moment(new Date()).add(item.rentPeriod, 'month').endOf('day').format('YYYY-MM-DD HH:mm:ss')
                this.leaseInfoParams.startStopDate = [...this.leaseInfoParams.startStopDate]

                // 赠送天数回显
                this.leaseInfoParams.presentDays = item.presentDays

                // 阶梯回显
                if (item.orderConfig && item.orderConfig.piecewiseCalculation.isOpen === 1) {
                  const { isOpen, unit, piecewiseConfigList } = item.orderConfig.piecewiseCalculation
                  this.ladderSchemeConfig = {
                    isOpen,
                    unit,
                    clickNumber: 1, // 匹配次数默认1
                    ladderSchemeList: [...piecewiseConfigList],
                  }
                  // 保存阶梯配置
                  this.leaseInfoParams.orderConfig = item.orderConfig
                }

                // 重置默认值
                this.tableDataFrom.tableData = [...this.defaultTableData]
                // 新增收款项
                item.orderPlanFeeList.forEach((order) => {
                  const { isOpen = 0, unit = 1, feePiecewiseConfigList = [] } = order.feeConfig?.feePiecewiseCalculation || {}
                  // 过滤掉已经有的收款项
                  // eslint-disable-next-line no-shadow
                  const isFundType = this.tableDataFrom.tableData.some((item) => {
                    return Number(item.fundType) === Number(order.type)
                  })
                  !isFundType && this.tableDataFrom.tableData.push({
                    fundType: order.type,
                    planAmount: order.payAmount,
                    payMode: order.payMethod,
                    feeConfig: {
                      feePiecewiseCalculation: {
                        isOpen,
                        unit,
                        feePiecewiseConfigList,
                      },
                    }, // 阶梯数据
                    payDay: (order.type === 1 && item.billDay) || '', // 租金的缴款日回显
                    dailyRule: item.dailyRule, // 日租金规则
                  })
                })
                // 计算需要开始结束时间
                this.$nextTick(() => {
                  this.$refs.PaymentPlanSetup && this.$refs.PaymentPlanSetup.FormCalculation()
                })
              }
            })
            this.$refs.AddVehicle && this.$refs.AddVehicle.plateNoRemoteMethod('', 'plateNo')
          }
        },
      },
    },
    {
      type: 'text',
      label: '上架单ID:',
      key: 'planRecordId',
    },
  ]
  // 企业客户信息默认值
  const m_enterprise_customerInfoDefaultValue = {
    rentCalculationRules: '企业客户',
  }
  // 企业客户信息校验
  const m_enterprise_customerInfo_rules = {}

  // 客户信息默认值
  const m_configDefaultValue = {
    rentCalculationRules: '个人客户',
    planId: '',
    customerName: '',
  }

  // 客户信息校验
  const m_configRules = {
    customerName: [
      { required: true, message: '请输入', trigger: 'blur' },
    ],
  }
  // 客户信息后半部分
  const m_infoConfigCloumn = [
    {
      type: 'text',
      label: '客户ID:',
      key: 'customerId',
    },
    {
      type: 'text',
      label: '联系电话:',
      key: 'customerTel',
    },
    {
      type: 'text',
      label: '身份证号:',
      key: 'idCardNo',
    },
    {
      type: 'text',
      label: '身份证有效期:',
      key: 'idCardValidDate',
    },
    {
      type: 'text',
      label: '驾照有效期:',
      key: 'driverLicenceValidDate',
    },
    {
      type: 'text',
      label: '人证有效期:',
      key: 'hailingLicenceValidDate',
    },
    // {
    //   type: 'text',
    //   label: '是否存在风险:',
    //   key: 'hasRisk'
    // },
    {
      type: 'text',
      label: '紧急联系人姓名:',
      key: 'emergencyContact',
    },
    {
      type: 'text',
      label: '紧急联系人电话:',
      key: 'emergencyContactTel',
    },
    {
      type: 'text',
      label: '紧急联系人关系:',
      key: 'emergencyContactRelation',
    },
  ]
  // 客户信息后半部分默认值
  const m_infoConfigDefaultValue = {}

  // 支付计划校验
  const m_rules = {
    presentDays: [
      { validator: validatorPresentDays.bind(this), trigger: 'change' },
    ],
    payDay: [
      { validator: validatorPayDay, trigger: 'change' },
    ],
  }
  // 支付计划底部统计默认展示列表
  const m_bottomTotalDefaultList = [
    {
      code: 1,
      number: 0,
    },
    {
      code: 2,
      number: 0,
    },
    {
      code: 3,
      number: 0,
    },
    {
      code: 4,
      number: 0,
    },
  ]
  // 周付 缴款日下拉列表
  const m_weekList = [
    {
      code: 1,
      name: '每周一',
    },
    {
      code: 2,
      name: '每周二',
    },
    {
      code: 3,
      name: '每周三',
    },
    {
      code: 4,
      name: '每周四',
    },
    {
      code: 5,
      name: '每周五',
    },
    {
      code: 6,
      name: '每周六',
    },
    {
      code: 7,
      name: '每周日',
    },
  ]
  //  关联订单信息默认值
  const m_relationOrderInfoDefaultValue = {}
  // 租赁车辆
  const m_thecarchange = [
    {
      type: 'select',
      label: '订车车型:',
      key: 'modelId',
      source: {},
      sourceKey: { label: 'modelName', value: 'modelId' },
      options: {
        clearable: true,
        disabled: false,
        change_s: (e) => {
          if (e) {
            this.plateNoRemoteMethod('', 'plateNo')
            // 更新车辆状态和绑定车辆
            this.m_thecarchange.forEach((current) => {
              if (current.key === 'vehicleStatus') {
                current.options.disabled = false
              }
              if (current.key === 'plateNo') {
                current.options.disabled = false
              }
            })
            this.m_thecarchangevalue.modelId = e
            this.m_thecarchangevalue.vehicleStatus = 3
            this.plateNoChange() // 更新车辆信息
            return
          }

          this.m_thecarchange.forEach((current) => {
            if (current.key === 'vehicleStatus') {
              current.options.disabled = true
            }
            if (current.key === 'plateNo') {
              current.options.disabled = true
            }
          })
          this.m_thecarchangevalue.modelId = ''
          this.m_thecarchangevalue.vehicleStatus = 3
          this.plateNoChange() // 更新车辆信息
        },
      },
    },
    {
      type: 'select',
      label: '车辆状态:',
      key: 'vehicleStatus',
      source: [{ id: 3, vehicleStatus: '待租' }],
      sourceKey: { label: 'vehicleStatus', value: 'id' },
      options: {
        disabled: true,
        change_s: () => {
          this.m_thecarchangevalue = Object.assign(this.m_thecarchangevalue, this.$refs.thecarchange.getValidKey())
          this.plateNoChange() // 更新车辆信息
          this.plateNoRemoteMethod('', 'plateNo')
        },
      },
    },
    {
      type: 'select',
      label: '绑定车辆:',
      key: 'plateNo',
      source: [],
      sourceKey: { label: 'plateNo', value: 'id' },
      options: {
        clearable: true,
        filterable: true,
        disabled: true,
        change_s: (e) => {
          this.m_thecarchangevalue = Object.assign(this.m_thecarchangevalue, this.$refs.thecarchange.getValidKey())
          this.plateNoChange(e) // 更新车辆信息
        },
      },
    },
    {
      type: 'text',
      label: '车辆ID:',
      key: 'carId',
    },
    {
      type: 'text',
      label: '车辆库存状态:',
      key: 'inventoryStateName',
    },
  ]
  // 企业车辆选择
  const m_enterprise_addVehicle = [
    {
      type: 'select',
      label: '订车车型:',
      key: 'modelId',
      source: {},
      sourceKey: { label: 'modelName', value: 'modelId' },
      options: {
        clearable: true,
        change_s: () => {
          this.$refs.AddVehicle.plateNoRemoteMethod('', 'plateNo')
        },
      },
    },
    {
      type: 'select',
      label: '添加车辆:',
      key: 'plateNo',
      source: [],
      sourceKey: { label: 'plateNo', value: 'id' },
      options: {
        clearable: true,
        filterable: true,
        change_s: (e) => {
          this.$refs.AddVehicle.currentPlateNoId = e
        },
      },
    },
  ]
  const m_enterprise_addVehicleDefaultValue = {}
  // 租赁车辆默认值
  const m_thecarchangevalue = {
    vehicleStatus: 3,
  }
  // 租赁车辆校验
  const m_thecarchangeRules = {
    modelId: [
      { required: true, message: '请选择', trigger: 'blur' },
    ],
    vehicleStatus: [
      { required: true, message: '请选择', trigger: 'blur' },
    ],
    plateNo: [
      { required: true, message: '请选择', trigger: 'blur' },
    ],
  }
  // 客户信息
  const m_configList = [
    {
      el: 'text',
      itemConfig: {
        label: '客户类型',
        prop: 'rentCalculationRules',
        value: '个人客户',
      },
    },
    {
      el: 'select',
      itemConfig: {
        label: '选择租赁方案',
        prop: 'planId',
      },
      elConfig: {
        disabled: true,
        options: {
          label: 'name',
          value: 'id',
          list: [],
        },
      },
    },
    {
      el: 'text',
      itemConfig: {
        label: '上架单ID',
        prop: 'planRecordId',
      },
    },
    {
      el: 'text',
      itemConfig: {
        label: '客户名称',
        prop: 'customerName',
        class: 'alone',
        width: 110,
      },
    },
    {
      el: 'text',
      itemConfig: {
        label: '客户ID',
        prop: 'customerId',
      },
    },
    {
      el: 'text',
      itemConfig: {
        label: '联系电话',
        prop: 'customerTel',
      },
    },
    {
      el: 'text',
      itemConfig: {
        label: '身份证号',
        prop: 'idCardNo',
      },
    },
    {
      el: 'text',
      itemConfig: {
        label: '身份证有效期',
        prop: 'idCardValidDate',
      },
    },
    {
      el: 'text',
      itemConfig: {
        label: '驾照有效期',
        prop: 'driverLicenceValidDate',
      },
    },
    {
      el: 'text',
      itemConfig: {
        label: '人证有效期',
        prop: 'hailingLicenceValidDate',
      },
    },
    {
      el: 'text',
      itemConfig: {
        label: '是否存在风险',
        prop: 'hasRisk',
      },
    },
    {
      el: 'text',
      itemConfig: {
        label: '紧急联系人姓名',
        prop: 'emergencyContact',
      },
    },
    {
      el: 'text',
      itemConfig: {
        label: '紧急联系人电话',
        prop: 'emergencyContactTel',
      },
    },
    {
      el: 'text',
      itemConfig: {
        label: '紧急联系人关系',
        prop: 'emergencyContactRelation',
      },
    },
  ]
  const m_configModel = {}
  // 订单转换模式 原订单相关信息
  const m_originOrderInfoList = [
    {
      el: 'text',
      itemConfig: {
        label: '司机合作模式已收押金',
        prop: 'receivedDeposit',
      },
    },
    {
      el: 'text',
      itemConfig: {
        label: '相关事故',
        prop: 'accidentCount',
      },
    },
    {
      el: 'text',
      itemConfig: {
        label: '维保状态',
        prop: 'maintenanceCount',
      },
    },
    {
      el: 'text',
      itemConfig: {
        label: '违章状态',
        prop: 'violationCount',
      },
    },
  ]
  const m_originOrderInfoModel = {}

  const m_vehicleList = [
    {
      el: 'select',
      itemConfig: {
        label: '订车车型',
        prop: 'modelId',
      },
      elConfig: {
        disabled: true,
        options: {
          label: 'modelName',
          value: 'modelId',
          list: [],
        },
      },
    },
    {
      el: 'select',
      itemConfig: {
        label: '车辆状态',
        prop: 'vehicleStatus',
        value: 3,
      },
      elConfig: {
        disabled: true,
        options: {
          label: 'vehicleStatus',
          value: 'id',
          list: [
            { id: 3, vehicleStatus: '待租' },
          ],
        },
      },
    },
    {
      el: 'select',
      itemConfig: {
        label: '绑定车辆',
        prop: 'plateNo',
      },
      elConfig: {
        disabled: true,
        options: {
          label: 'plateNo',
          value: 'id',
          list: [],
        },
      },
    },
    {
      el: 'text',
      itemConfig: {
        label: '车辆ID',
        prop: 'carId',
      },
    },
    {
      el: 'text',
      itemConfig: {
        label: '车辆库存状态',
        prop: 'inventoryStateName',
      },
    },
  ]
  const m_vehicleModel = {}
  // 阶梯配置 默认两个阶梯
  const ladderSchemeConfig = {
    isOpen: 0,
    unit: 1,
    clickNumber: 0, // 点击匹配租金次数
    ladderSchemeList: [
      {
        startMonth: 1, // 开始时间为1
        endMonth: '',
        amount: '',
      },
      {
        startMonth: '',
        endMonth: '',
        amount: '',
      },
    ],
  }
  //  关联订单信息
  const m_relationOrderInfo = [
    {
      el: 'text',
      itemConfig: {
        label: '关联原因',
        prop: 'relatedTypeName',
      },
    },
    {
      el: 'input',
      itemConfig: {
        label: '关联合同说明',
        prop: 'relatedExplain',
      },
      elConfig: {
        clearable: true,
        type: 'textarea',
        maxlength: 500,
      },
    },
  ]
  const m_relationOrderInfoModel = {}
  return {
    m_originOrderInfoList, // 订单转换模式 原订单相关信息
    m_originOrderInfoModel,
    ladderSchemeConfig, // 阶梯配置
    m_enterprise_customerInfo, // 企业客户信息
    m_enterprise_customerInfoDefaultValue, // 企业客户信息默认值
    m_enterprise_customerInfo_rules, // 企业客户信息校验
    m_configList, // 客户信息
    m_configModel,
    m_vehicleList, // 车辆选择list
    m_vehicleModel,
    m_configDefaultValue, // 客户信息默认值
    m_configRules, // 客户信息校验
    m_infoConfigCloumn, // 客户信息后半部分
    m_infoConfigDefaultValue, // 客户信息后半部分默认值
    m_rules, // 支付计划校验
    m_bottomTotalDefaultList, // 支付计划底部统计默认展示列表
    m_weekList, // 周付 缴款日下拉列表
    m_relationOrderInfoDefaultValue, // 关联订单信息默认值
    m_thecarchange, // 租赁车辆
    m_thecarchangevalue, // 租赁车辆默认值
    m_thecarchangeRules, // 租赁车辆校验
    m_enterprise_addVehicle, //
    m_enterprise_addVehicleDefaultValue, //
    m_relationOrderInfo,
    m_relationOrderInfoModel,
  }
}
